function display()
{
    console.log("hello");
    $.ajax({
        url : 'https://ppdrvm5m11q57r3q-20445527.shopifypreview.com/collections/all?view=json',
        type : "GET",
        success : function(response) {
            if(response) {
                 console.log(response);
    

//                  response.forEach(async(element) => {​​​​​​​​
//                     console.log(element);
// });
                //  Object.values(response).forEach(test => {
                //     console.log(test);
                //  });
         
                let template = $('#handlebars-demo').html();
                //console.log(template);
                let templateScript = Handlebars.compile(template);
                //console.log(templateScript);
                // let test = {
                //     'firstname' : "Yehuda",
                //     'lastname' : "Katz",
                //   };
                // //console.log(test)
                // let ht = templateScript(test);
                // console.log(ht);
                // $('#newList').append(ht);
             


                // console.log(response);
                // for (let x in response) {
                //     console.log(x + ": "+ response[x])
                //  }
                // console.log(response);
                // let test = {
                //         'firstname' : "Yehuda",
                //         'lastname' : 98,
                //       };
                // console.log(typeof(test))
                res =JSON.parse(response);
                // // arr = [];
                // obj = [];
                for (var i = 0; i < 3; i++) {
                    demo = {'id': res[i].id};
                    //obj.push(demo);
                    // formatedData = JSON.stringify(demo);
                
                    //console.log(typeof(obj));
                    let ht = templateScript(demo);
                    console.log(ht);
                    $('#newList').append(ht);
                }
                // console.log(JSON.stringify(arr));
            }
        },
        error :function(error) {
            console.log(error);
        }    
    });
}
